module.exports = __webpack_public_path__ + "static/img/bg-fr.427b6249.webp";